/**
 * Derives shell visibility flags from the current pathname.
 * Centralizes route-mode logic previously split across AppLayout and Header.
 */
export function getLayoutMode(pathname = '') {
  const isTestRoute = pathname.startsWith('/r/test/');
  const isStudentRoute = pathname.startsWith('/r/student');
  const isStudioRoute = pathname.startsWith('/r/machadalostudio/');
  const isInterveneRoute = pathname.startsWith('/r/v2/intervene');

  return {
    hideSidebar: isTestRoute,
    hideHeader: isStudentRoute || isStudioRoute,
    showTestHeader: isTestRoute,
    headerVariant: isTestRoute ? 'test' : 'default',
    lockContentScroll: isInterveneRoute,
  };
}

export default getLayoutMode;
